import { Button, PickerMap } from '@schuettflix/react-components';
import { Coordinates } from '@/modules/location/domain/GeoAddressSchema.ts';
import React from 'react';
import { WizardPanel } from '@/shared/components/Wizard.tsx';
import { useTranslation } from 'react-i18next';

type LoadingPointPanelProps = {
    apiKey: string;
    language: string;
    transferPoint: Coordinates;
    zoomLevel: number;
    onClose: () => void;
    onSubmit(address: Coordinates): void;
};

export const TransferPointPanel: React.FC<LoadingPointPanelProps> = (props: LoadingPointPanelProps) => {
    const { t } = useTranslation();
    const [transferPoint, setTransferPoint] = React.useState<Coordinates>(props.transferPoint);

    const handleSubmit = (transferPoint: Coordinates): void => {
        props.onSubmit(transferPoint);
    };

    return (
        <WizardPanel
            noMaximize
            noPadding
            onClose={() => {
                props.onClose();
            }}
            title={t('location.newAddress.loadingSpecification.panel.title')}
            footer={<LoadingPointPanelFooter onClick={() => handleSubmit(transferPoint)} />}
        >
            <PickerMap
                apiKey={props.apiKey}
                language={props.language}
                initialCoordinates={transferPoint}
                initialZoom={props.zoomLevel}
                defaultMapType={'hybrid'}
                showAddressPicker={false}
                mapTypeLabels={{
                    mapTypeHeadline: t('location.mapTypeLabels.mapTypeHeadline'),
                    roadmap: t('location.mapTypeLabels.roadmap'),
                    satellite: t('location.mapTypeLabels.satellite'),
                    hybrid: t('location.mapTypeLabels.hybrid'),
                }}
                value={null}
                onChange={geoAddress => {
                    if (!geoAddress || !geoAddress.coordinates.openLocationCode) return;

                    setTransferPoint({
                        latitude: geoAddress.coordinates.latitude,
                        longitude: geoAddress.coordinates.longitude,
                        openLocationCode: geoAddress.coordinates.openLocationCode,
                    });
                }}
            />
        </WizardPanel>
    );
};

interface LoadingPointPanelFooterProps {
    onClick: () => void;
}

export const LoadingPointPanelFooter: React.FC<LoadingPointPanelFooterProps> = (
    props: LoadingPointPanelFooterProps
) => {
    const { t } = useTranslation();

    return (
        <div className="flex justify-end">
            <Button label={t('common.save')} size="sm" onClick={props.onClick} />
        </div>
    );
};
